export let basicProps = {
    id: 0,
    menu_name: ''
}




// WEBPACK FOOTER //
// ./src/store/modules/subMenu/properties.js